/**
 * Executes a callback function when DOM is ready.
 * If DOM is already loaded, executes immediately.
 * Otherwise waits for DOMContentLoaded event.
 */
export const onDomReady = (callback: () => void): void => {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback);
    } else {
        callback();
    }
};

/**
 * Executes an async callback function when DOM is ready.
 * If DOM is already loaded, executes immediately.
 * Otherwise waits for DOMContentLoaded event.
 */
export const onDomReadyAsync = (callback: () => Promise<void>): void => {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback);
    } else {
        callback();
    }
};
